import { render, staticRenderFns } from "./ActScores.vue?vue&type=template&id=10851de6&scoped=true&"
import script from "./ActScores.vue?vue&type=script&lang=js&"
export * from "./ActScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10851de6",
  null
  
)

export default component.exports